// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2-YR--WsJmp9Az {\n  font-size: 12px;\n  text-decoration: underline;\n  cursor: pointer;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ctaButton": "_2-YR--WsJmp9Az"
};
export default ___CSS_LOADER_EXPORT___;
